export default __webpack_public_path__ + "be2b6ef82327acae86211c21fc1391b0.png";